import React from 'react';
import Styles from './CarrosEletricosBanner.css';
import RedButton from '../../atoms/RedButton';
import Container from '../../atoms/Container';

function CarrosEletricosBanner() {
  return (
    <>
      <section className={'banner_mobile'}>
        <Container>
          <h1 className={'campanha_txt'}>
            Financie seu <b>carro</b> ou <b>moto elétrica</b> com taxas reduzidas no Santander
          </h1>
          <p className={'xxx_txt'}>
            Invista no futuro da mobilidade com quem oferece as melhores vantagens do mercado.
          </p>
          <RedButton
            href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
            id="simular-banner-mobile"
            target="_blank"
            rel="noopener"
          >
            Simular
          </RedButton>
        </Container>
      </section>

      <section className={'banner_desk'}>
        <Container>
          <div className={'div_desk'}>
            <h1 className={'vantagens_txt'}>
              Financie seu <b>carro</b> ou <b>moto elétrica</b>
              <br />
              com taxas reduzidas no Santander
            </h1>
            <p className={'produtos_txt'}>
              Invista no futuro da mobilidade com quem oferece as melhores vantagens do mercado.
            </p>
            <RedButton
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
              id="simular-banner-desktop"
              target="_blank"
              rel="noopener"
            >
              Simular
            </RedButton>
          </div>
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosBanner;
